import React, { useState, useEffect } from "react";
import { Card, CardBody, CardImg, CardSubtitle } from "reactstrap";
import { makeStyles } from "@material-ui/styles";
import { Divider, Tooltip } from "@material-ui/core";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import EditIcon from "@material-ui/icons/Edit";
import CheckIcon from "@material-ui/icons/Check";
import EditInput from "app/routes/dashboard/routes/library/components/UIs/EditInput.";
// import CardMenu from "./CardMenu";
import IconButton from "@material-ui/core/IconButton";
import { useDispatch } from "react-redux";
// import moment from "moment";
import Downloader from "../Downloader";
import filteringName from "../../filteringExtension/filteringName";
// import filteringTime from "../../filteringExtension/filteringTime";
import Popover from "@material-ui/core/Popover";
import Typography from "@material-ui/core/Typography";
// import Button from "@material-ui/core/Button";

import {
  changeCurFolderByContent,
  editContentTitle,
} from "app/routes/dashboard/routes/library/slice/libraryThunks";
import iconSelector from "../icons/iconSelctor";
import getDateFns from "util/getDateFn";
import { checkCutStatus, setCutContent } from "../../slice/librarySlice";
import ReviseModal from "../Modals/ReviseModal";

const useStyles = makeStyles({
  popover: {
    width: 120,
    height: "auto",
    padding: 16,
    display: "flex",
    flexDirection: "column",
    cursor: "pointer",
  },
  more: {
    position: "absolute",
    right: 36,
  },
  close: {
    position: "absolute",
    right: 0,
    top: 4,
  },
  moreP: {
    position: "absolute",
    right: 8,
    top: 8,
  },
  download: {
    position: "absolute",
    left: 16,
  },
  image: {
    display: "flex",
    width: 60,
    alignSelf: "center",
    margin: "8px 8px 0",
  },
  divider: {
    marginBottom: 22,
  },
  subtitle: {
    display: "flex",
    justifyContent: "flex-start",
    alignSelf: "center",
    marginTop: 8,
  },
  title: {
    color: "#364a63",
    textAlign: "center",
  },
  icon: {
    marginLeft: 4,
    color: "#364a63",
  },
  unpublish: {
    backgroundColor: "#d5d5d5",
  },
});

const ContentCard = (props) => {
  const dispatch = useDispatch();

  const {
    // id,
    image,
    title,
    // subTitle,
    type,
    content,

    current,
    handleDrawer,
    is_published,
  } = props;

  const classes = useStyles();

  const [anchorEl, setAnchorEl] = React.useState(null);

  const [inputStatus, setInputStatus] = useState(false);

  const [reviseModal, setReviseModal] = useState(false);

  function HandleInputStatus() {
    setInputStatus(!inputStatus);
  }

  const [name, setName] = useState(title);

  function handleKeyDown(e) {
    if (e.key === "Enter") {
      e.preventDefault();
      onAction("EDIT_TITLE")();
    }
  }
  function onOptionMenuSelect(event) {
    handleDrawer(true, content, current);
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleIconClick = (type) => () => {
    switch (type) {
      case "folder":
        dispatch(checkCutStatus(content));
        dispatch(changeCurFolderByContent(content, "push"));
        break;

      default:
        break;
    }
  };

  const onAction = (action) => () => {
    switch (action) {
      case "EDIT_TITLE":
        setInputStatus(false);
        dispatch(editContentTitle(content, name, current));
        break;

      default:
        break;
    }
  };

  function handleChange(e) {
    const { value } = e.target;
    setName(value);
  }

  useEffect(() => {
    setName(title);
  }, [title]);

  let icon = image;
  const open = Boolean(anchorEl);
  const idp = open ? "simple-popover" : undefined;
  if (type === "file") icon = iconSelector(content.src.mimetype);

  function handleOpenReviseModal() {
    setReviseModal(true);
    handleClose();
  }

  function handelCloseReviseModal() {
    setReviseModal(false);
  }

  function handleCutContent() {
    dispatch(
      setCutContent({
        content,
        current,
      })
    );
    handleClose();
  }
  // if (type === "file") console.log(iconSelector(content.src.mimetype));

  return (
    <React.Fragment>
      <Card
        className={`shadow ${is_published ? "border-0" : classes.unpublish}`}
      >
        <div onClick={onOptionMenuSelect}>
          <IconButton className={classes.more}>
            <i className="zmdi zmdi-eye" />
          </IconButton>
        </div>
        <IconButton
          onClick={handleClick}
          className={`${classes.moreP} jr-menu-icon`}
          aria-label="Menu"
        >
          <i className="zmdi zmdi-more-vert" />
        </IconButton>
        <Popover
          id={idp}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "center",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "center",
            horizontal: "center",
          }}
        >
          <Typography className={classes.popover}>
            <IconButton
              onClick={handleClose}
              className={`${classes.close} jr-menu-icon`}
              aria-label="Menu"
            >
              <i className="zmdi zmdi-close" size="small" />
            </IconButton>
            <div className="mt-2" onClick={handleCutContent}>
              Cut
            </div>
            {type === "file" ? (
              <React.Fragment>
                <Divider />
                <div className="mt-2" onClick={handleOpenReviseModal}>
                  Revise
                </div>
              </React.Fragment>
            ) : (
              false
            )}
          </Typography>
        </Popover>
        {type === "file" ? (
          <Downloader
            fileId={content.src && content.src.id}
            fileName={content.title}
            fileExtension={content.extension}
          >
            <IconButton className={classes.download}>
              <i className="zmdi zmdi-download" />
            </IconButton>
          </Downloader>
        ) : (
          false
        )}
        <CardImg
          className={classes.image}
          top
          src={icon}
          width="50px"
          alt="Card image cap"
          onClick={handleIconClick(type)}
        />
        <CardBody>
          <div className="d-flex justify-content-center">
            {!inputStatus ? (
              <Tooltip placement="top" title={title}>
                <h3 className={`card-title ${classes.title}`}>
                  {filteringName(name, 15)}
                </h3>
              </Tooltip>
            ) : (
              <EditInput
                onKeyDown={handleKeyDown}
                onChange={handleChange}
                value={name}
              />
            )}

            {inputStatus ? (
              <CheckIcon
                size="small"
                onClick={onAction("EDIT_TITLE")}
                className={classes.icon}
              />
            ) : (
              <Tooltip placement="top" title={title}>
                <EditIcon
                  size="small"
                  onClick={HandleInputStatus}
                  className={classes.icon}
                />
              </Tooltip>
            )}
          </div>

          <Divider className={classes.divider} />
          <div className={classes.subtitle}>
            {
              getDateFns("diffFromToday")(content.created_time)
              // filteringTime(
              //   moment(content.created_time).locale("ir").startOf("hour").fromNow()
              // )
            }{" "}
            by {content.created_by?.known_as}
          </div>
        </CardBody>
      </Card>
      <ReviseModal
        current={current}
        content={content}
        open={reviseModal}
        handleClose={handelCloseReviseModal}
        handleOpen={handleOpenReviseModal}
      />
    </React.Fragment>
  );
};

export default ContentCard;
